import { createStore } from 'vuex';
import { Service } from '@/adapters/serviceQualificationAdapterInterface';
import { Catalog, Product } from '@/adapters/catalogAdapterInterface';
import { Account } from '@/services/authentication/authenticationServiceInterface';
import { AnnouncementData, Outages } from '@/services/integration/clients/types';
import { LoadedCart } from '@/utils/cartLoader';

export type OrderSelection = {
  selectedProducts: Product[],
  promoCode?: string,
  isVoipListed: boolean
}

type State = {
  serviceQualification: Service | null,
  catalog: Catalog | null,
  account: Account | null,
  salesPerson: string | null,
  paymentAttempts: number,
  outages: Outages | null,
  announcements: AnnouncementData[],
  cartId: string | null,
  orderSelection: OrderSelection | null,
  loadedCart: LoadedCart | null
}

/**
 * Store stuff here that needs to be persisted through a page change using
 * vue-router.
 *
 * And nothing else :P
 */
export default createStore<State>({
  state: {
    serviceQualification: null,
    catalog: null,
    account: null,
    salesPerson: null,
    paymentAttempts: 0,
    outages: null,
    announcements: [],
    cartId: null,
    orderSelection: null,
    loadedCart: null
  },
  mutations: {
    setServiceQualification (state, service: Service) {
      state.serviceQualification = service;
      // Selection and any cart belong to the previous address.
      state.orderSelection = null;
      state.loadedCart = null;
      state.cartId = null;
    },

    setCatalog (state, catalog: Catalog) {
      state.catalog = catalog;
    },

    setAccount (state, account: Account) {
      state.account = account;
    },

    setSalesPerson (state, email: string) {
      state.salesPerson = email;
    },

    setPaymentAttempt (state, num: number) {
      state.paymentAttempts = num;
    },

    setOutages (state, outages: Outages) {
      state.outages = outages;
    },

    setAnnouncements (state, announcements: AnnouncementData[]) {
      state.announcements = announcements;
    },

    setCartId (state, cartId: string) {
      state.cartId = cartId;
    },

    setOrderSelection (state, orderSelection: OrderSelection | null) {
      state.orderSelection = orderSelection;
    },

    // A cart opened with ?cartId= that is being edited.
    setLoadedCart (state, loadedCart: LoadedCart | null) {
      state.loadedCart = loadedCart;
    }
  },
  actions: {},
  modules: {}
});
